import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcFavoriteH18(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    fill: "none",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.19 6.817c0-1.84-1.433-3.291-3.15-3.292-1.02 0-1.933.507-2.513 1.308l-.526.727-.526-.727c-.58-.8-1.494-1.307-2.513-1.308-1.717 0-3.15 1.452-3.15 3.292 0 .795.307 1.514.782 2.139l.214.263.006.008.006.007c.327.4 1.575 1.706 2.847 3.007.913.935 1.805 1.834 2.336 2.357.53-.523 1.423-1.42 2.335-2.356 1.27-1.301 2.516-2.607 2.843-3.008l.013-.015c.596-.684.995-1.493.995-2.402m1.3 0c0 1.312-.581 2.412-1.315 3.255h-.001c-.39.471-1.672 1.813-2.905 3.077-1.251 1.282-2.515 2.551-2.83 2.834a.65.65 0 0 1-.87 0c-.315-.283-1.58-1.55-2.833-2.833-1.249-1.278-2.55-2.636-2.923-3.093-.727-.841-1.301-1.937-1.301-3.24 0-2.513 1.97-4.592 4.45-4.592A4.36 4.36 0 0 1 9 3.464a4.36 4.36 0 0 1 3.04-1.24c2.48 0 4.45 2.08 4.45 4.593"
  }));
}
var IcFavoriteH18 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFavoriteH18));

export { IcFavoriteH18 as I };
